module.exports = __webpack_public_path__ + "ff32e7fec67c2f3c6ed985688f5db5dc.MP3";